const prod = {
  SERVER_URL: "https://rigenera.comunica.live/api",
  SAMPLE_DATA: false,
  APP_NAME: "Rigenera",
};

const dev = {
  SERVER_URL: "http://localhost:8080/api",
  SAMPLE_DATA: false,
  APP_NAME: "Rigenera dev.",
};

export const config = process.env.NODE_ENV === "production" ? prod : dev;
